import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'fusion-ms-line-chart',
  templateUrl: './ms-line-chart.component.html',
  styleUrls: ['./ms-line-chart.component.scss']
})
export class FusionMSLineChartComponent implements OnInit, OnChanges {
  @Input() chartCaption?: string;
  @Input() xaxisCatgoryList: string[];
  @Input() dataSeries: any[];
  @Input() height?: string = '200px';
  @Input() xAxisName?: string = '';
  @Input() showvalues?: string = '1';

  /*

    Category Sample Object 
    {
      label: 'abc'
    }

    Data Series Sample Object
    {
      seriesname: "Original",
      color: "#ff0000",
      data: []
    }

    Data Series Data Sample Object 
    {
      value: 123
    }
  */

  dataSource: any = {
    chart: {
      caption: "",
      theme: "fusion",
      labelDisplay: "rotate",
      slantLabel: "1",
      maxLabelHeight: "100",
      chartLeftMargin: "5",
      chartRightMargin: "5",
      chartBottomMargin: "0",
      canvasPadding: "0",
      showBorder: "1",
      borderColor: "#8D009D",
      borderThickness: "2",
      borderAlpha: "20",
      plotHighlightEffect: "fadeout",
      legendPosition: "top-left",
      // legendPosition: "absolute",
      // legendXPosition: "40",
      // legendYPosition: "5",
      showvalues: this.showvalues,
    },
    categories: [
      {
        category: []
      }
    ],
    dataset: []
  };

  chartConfig: Object = {
    type: 'msline',
    dataFormat: 'json',
  };


  constructor() {

  }

  ngOnInit() {
    this.initChartDataSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initChartDataSource();
  }

  initChartDataSource() {
    this.dataSource.chart.caption = this.chartCaption;
    this.dataSource.chart.xAxisName = this.xAxisName;
    this.dataSource.categories[0].category = this.xaxisCatgoryList;
    this.dataSource.dataset = this.dataSeries;
  }

}
